import React, { useState, useRef, useEffect } from 'react';
import { 
    MoreVertical, Eye, Download, Mail, 
    FileText, Calendar 
} from 'lucide-react';

// --- SINGLE REPORTS ITEM ---
const ReportsItem = ({ setPageIsLoading, pageIsLoading, report, manageViewButton, frameworkId, onDownload, onEmail }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const formatDate = (dateString) => {
        if (!dateString) return 'Just now';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric', month: 'short', day: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    return (
        <div className="group bg-white rounded-2xl ring-1 ring-slate-200/60 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:shadow-lg hover:shadow-indigo-500/5 hover:ring-indigo-200 hover:- transition-all duration-300">
            {/* Left Info Section */}
            <div className="flex items-start sm:items-center gap-4">
                <div className="p-3.5 bg-gradient-to-br from-indigo-50 to-blue-50 text-indigo-600 rounded-xl ring-1 ring-indigo-100/50 group-hover:scale-110 group-hover:bg-indigo-100 transition-all shadow-sm">
                    <FileText size={20} strokeWidth={2.5} />
                </div>
                <div>
                    <h4 className="font-extrabold text-slate-900 text-base mb-1 group-hover:text-indigo-700 transition-colors">
                        {report?.reportName || 'Compliance Status Report'}
                    </h4>
                    <div className="flex items-center gap-2 text-slate-500">
                        <Calendar size={13} />
                        <span className="text-xs font-bold uppercase tracking-wider">
                            {formatDate(report?.reportDate)}
                        </span>
                    </div>
                </div>
            </div>

            {/* Right Actions Section */}
            <div className="flex items-center gap-2 sm:mt-0 ml-14 sm:ml-0">
                {/* Primary Action Button */}
                <button
                    onClick={() => manageViewButton(true, report)}
                    className="flex items-center justify-center gap-2 px-4 py-2 text-sm font-bold text-indigo-700 bg-indigo-50 ring-1 ring-indigo-200/50 rounded-xl hover:bg-indigo-600 hover:text-white hover:ring-indigo-600 transition-colors shadow-sm"
                >
                    <Eye size={16} /> <span className="hidden sm:inline">Preview</span>
                </button>

                {/* Modern 3-Dot Dropdown for Secondary Actions */}
                <div className="relative shrink-0">
                    <button
                        onClick={(e) => { e.stopPropagation(); setIsMenuOpen(!isMenuOpen); }}
                        onBlur={() => setTimeout(() => setIsMenuOpen(false), 200)}
                        className="p-2 text-slate-400 hover:text-slate-900 hover:bg-slate-100 rounded-xl transition-all ring-1 ring-transparent hover:ring-slate-200/60"
                    >
                        <MoreVertical size={20} />
                    </button>

                    {isMenuOpen && (
                        <div className="absolute right-0 top-full mt-2 w-48 bg-white/90 backdrop-blur-xl rounded-2xl shadow-[0_8px_30px_rgb(0,0,0,0.12)] z-50 ring-1 ring-slate-200/60 py-2 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                            <button
                                onClick={(e) => { e.preventDefault(); onDownload?.(report); setIsMenuOpen(false); }}
                                className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition-colors"
                            >
                                <Download size={16} /> Download PDF
                            </button>
                            <button
                                onClick={(e) => { e.preventDefault(); onEmail?.(report); setIsMenuOpen(false); }}
                                className="w-full flex items-center gap-2 px-4 py-2.5 text-sm font-semibold text-slate-700 hover:bg-slate-50 hover:text-indigo-600 transition-colors"
                            >
                                <Mail size={16} /> Email Report
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReportsItem;